import { ShieldAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface AccessDeniedProps {
  message?: string;
}

export function AccessDenied({ message }: AccessDeniedProps) {
  const { t } = useTranslation('settings');
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <ShieldAlert className="size-10 text-muted-foreground mb-3" />
      <h2 className="text-lg font-semibold mb-1">{t('accessDenied.title')}</h2>
      <p className="text-sm text-muted-foreground max-w-sm">
        {message ?? t('accessDenied.message')}
      </p>
    </div>
  );
}
